import { ErrorIcon } from 'assets/images';
import { CustomModal } from 'components/commons/CustomModal/CustomModal';
import React from 'react';

import { useLogout } from '~hooks/useLogout';

import './BillingSuspensionBlockingModal.scss';

const RESTORE_ACCESS_LINK =
	'mailto:billing@trycents.com?subject=Suspended Account - Restore Access';

interface BaseBillingSuspensionModalProps {
	children: React.ReactNode;
}

export const BaseBillingSuspensionModal = ({
	children,
}: BaseBillingSuspensionModalProps) => {
	const { logout } = useLogout();

	const Footer = (
		<span role="button" tabIndex={0} className="logout-btn" onClick={logout}>
			Logout
		</span>
	);

	return (
		<CustomModal
			isOpen
			titleIcon={ErrorIcon}
			title="Your account has been turned off due to non-payment."
			haveCloseButton={false}
			onSubmit={() => {
				window.open(RESTORE_ACCESS_LINK);
			}}
			submitText="Contact us now"
			footer={Footer}
			className="billing-suspension-modal"
		>
			<p className="blocking-modal-text">{children}</p>
		</CustomModal>
	);
};
